import React,{Component} from 'react';
import ContentRightClientsSlider from  './content-right-clients-slider/content-right-clients-slider'
import {Link} from 'react-router-dom'

class ContentRightClients extends Component {
    render() {

        return(
            <div>
                <div class="our-clients">
                    <span>Our Clients Include</span>
                    <span class="pull-right"><Link to="/clients">View All</Link></span>
                </div>

                <ContentRightClientsSlider />



            </div>
        )
    }
}

export default ContentRightClients;


// WEBPACK FOOTER //
// ./src/report-description/content/content-right/content-right-clients/content-right-clients.js